module.exports = __webpack_public_path__ + "img/reset_doorbell_step_2.a3420c6c.png";